import { navigate } from 'gatsby';
import React, { use } from 'react';

import { ClubCmsContent } from 'src/content/club-content-consumer';
import { useLink } from 'src/custom-hooks/use-link';
import { navigateToExternalPage } from 'src/helpers/navigation-helper';

type MobileNavLinkProps = {
  id: string;
  path: string;
  text: string;
  closeNav: () => void;
};

const MobileNavLink: React.FC<MobileNavLinkProps> = ({ id, path, text, closeNav }) => {
  const cmsContent = use(ClubCmsContent);
  const { isPageDisabledInCms, isInternalLink, translatedPath, useGatsbyPath } = useLink({
    toPath: path,
    enabledClubPages: cmsContent?.pages,
  });

  if (isPageDisabledInCms && isInternalLink) {
    return null;
  }

  return (
    <div
      id={id}
      css={{ cursor: 'pointer' }}
      onClick={() => {
        if (isInternalLink && useGatsbyPath) {
          navigate(translatedPath);
        } else {
          navigateToExternalPage(translatedPath);
        }
        closeNav();
      }}
    >
      {text}
    </div>
  );
};

export default MobileNavLink;
